import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinnavimumbai() {



  const cardData =
  {
    keyword: 'Cab Service in Navi Mumbai',
    heading: 'Shambhu Cabs: Cab Service in Navi Mumbai',
    headingDescription: 'Shambhu Cabs offers reliable Cab Service in Navi Mumbai, providing safe, comfortable, and hassle-free travel for daily commuters, families, corporate travelers, and outstation passengers across the city. Whether you need a cab for airport transfers, office travel, shopping trips, hospital visits, or weekend getaways, our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and convenient ride. With experienced chauffeurs, flexible one-way and round-trip options, and 24/7 booking support, Shambhu Cabs delivers timely, dependable transportation in Airoli, Vashi, Nerul, Kharghar, Panvel, and all nearby areas. For those seeking comfort, punctuality, and professional service, Shambhu Cabs is the most trusted cab service in Navi Mumbai.',

    top: 'Top Places to Visit in Navi Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Nerul Balaji Temple",
    "description": "The Nerul Balaji Temple, inspired by the famed Tirupati Balaji shrine, is one of Navi Mumbai’s most visited spiritual attractions. Built atop a small hillock, the temple features Dravidian-style architecture, intricately carved gopurams, and a tranquil prayer hall dedicated to Lord Venkateswara. Devotees climb a series of steps to reach the shrine, enjoying panoramic city views and peaceful surroundings. Festive days like Vaikunta Ekadashi draw huge crowds, showcasing Navi Mumbai’s devotional culture and serene atmosphere."
  },
  {
    "title": "Kharghar Hills & Valley",
    "description": "Kharghar Hills is a scenic escape offering lush greenery, trekking routes, waterfalls during monsoons, and breathtaking viewpoints. Popular spots include the ISKCON Temple hill area, Hiker’s Point, and meditation plazas. During the rainy season, the hills come alive with streams and mist-covered landscapes, attracting nature lovers, trekkers, and photographers. Its wide open spaces and fresh air make it a perfect retreat within the urban limits of Navi Mumbai."
  },
  {
    "title": "Central Park, Kharghar",
    "description": "Central Park in Kharghar is one of India’s largest urban parks, spread across 300 acres with botanical gardens, musical fountains, jogging tracks, amphitheaters, lotus ponds, and recreational spaces. The park’s well-maintained lawns and picturesque landscapes make it ideal for morning exercise, family picnics, and outdoor photography. Themed gardens, a golf course nearby, and year-round cultural events add to its charm, making it a true green oasis in Navi Mumbai."
  },
  {
    "title": "Pandavkada Waterfall",
    "description": "Pandavkada Waterfall in Kharghar is a spectacular monsoon destination where water cascades from a height of nearly 107 meters. According to legend, the Pandavas once visited this spot, giving it mythological significance. Visitors enjoy trekking through lush green trails, misty air, and scenic views during rainy months. The natural beauty and refreshing surroundings make it a popular attraction for adventure seekers and nature lovers."
  },
  {
    "title": "DY Patil Stadium",
    "description": "The DY Patil Stadium in Nerul is one of India’s finest sports arenas, famous for hosting IPL matches, international cricket, football tournaments, and large concerts. Its modern architecture, massive seating capacity, and state-of-the-art facilities make it a landmark structure in Navi Mumbai. The illuminated stadium during events creates a vibrant atmosphere, attracting sports fans and concert-goers from across the region."
  },
  {
    "title": "Nerul Lake & Nature Park",
    "description": "Nerul Lake is a serene natural getaway featuring a picturesque waterfront, jogging tracks, birdwatching spots, and landscaped gardens. Home to migratory birds during winter, the lake attracts nature enthusiasts seeking quiet surroundings away from city noise. The adjacent nature park offers walking paths, children’s play areas, and scenic viewpoints, making it ideal for evening strolls, photography, and relaxation."
  },
  {
    "title": "Rock Garden, Nerul",
    "description": "Rock Garden is a well-designed urban park featuring rock sculptures, children’s play zones, a small pond, and walking paths surrounded by greenery. Families visit to enjoy peaceful evenings, outdoor activities, and photography. The landscaped garden, artistic stone formations, and open-air seating areas create a refreshing escape, making it one of Navi Mumbai’s most popular leisure spots."
  },
  {
    "title": "Belapur Mango Garden",
    "description": "Belapur Mango Garden is a beautifully landscaped park known for its mango trees, boating lake, play areas, and shaded walkways. The park offers a peaceful environment for families, joggers, and picnickers. Seasonal mango blossoms add fragrance, while the lake and lush greenery make it a preferred spot for outdoor relaxation and morning walks."
  },
  {
    "title": "Wonders Park, Nerul",
    "description": "Wonders Park is a family-friendly amusement park featuring replicas of the Seven Wonders of the World, toy train rides, open gyms, amphitheaters, and well-maintained gardens. Children enjoy the play zones, while adults appreciate the scenic walking tracks and relaxing atmosphere. The illuminated evenings add a magical touch, making it a delightful recreation spot in Navi Mumbai."
  },
  {
    "title": "Inorbit Mall, Vashi",
    "description": "Inorbit Mall in Vashi is one of Navi Mumbai’s premier shopping and entertainment destinations, offering branded stores, multiplex cinemas, gaming zones, and a variety of dining options. The mall attracts shoppers, families, and youngsters due to its vibrant atmosphere, weekend events, and modern interior. It serves as a popular hangout spot for leisure, shopping sprees, and culinary experiences."
  },
  {
    "title": "Parsik Hill",
    "description": "Parsik Hill stretches across Navi Mumbai and offers scenic sunset viewpoints, trekking trails, and panoramic views of the city and Thane Creek. The area is popular among cyclists, hikers, and fitness enthusiasts. Its lush greenery, peaceful environment, and elevated vantage points make it an excellent destination for early morning activities and nature retreats."
  }
],




"services": [
  {
    "name": "Navi Mumbai Taxi",
    "description": "Navi Mumbai Taxi provides reliable and comfortable cab services for all kinds of travel within Navi Mumbai. Ideal for daily commutes, airport transfers, and intercity travel, the service features experienced drivers, well-maintained vehicles, and timely pickups. Passengers can enjoy 24×7 availability, professional chauffeurs, and easy online booking with transparent pricing for a hassle-free experience."
  },
  {
    "name": "Cab Near Me Navi Mumbai",
    "description": "Cab Near Me Navi Mumbai allows passengers to quickly locate and book nearby cabs for immediate travel. With prompt pickups, clean and air-conditioned vehicles, and skilled drivers, this service ensures safe, convenient, and affordable travel across Navi Mumbai neighborhoods and surrounding areas."
  },
  {
    "name": "Affordable Cab Navi Mumbai",
    "description": "Affordable Cab Navi Mumbai offers budget-friendly taxi services without compromising comfort or safety. Passengers can avail of AC and non-AC vehicles for city rides, airport transfers, and outstation trips. The service provides transparent fare estimates, flexible booking options, and experienced chauffeurs for a smooth travel experience."
  },
  {
    "name": "Best Cab Service Navi Mumbai",
    "description": "Best Cab Service Navi Mumbai provides premium taxi services with professional drivers, timely pickups, and clean, well-maintained vehicles. Suitable for families, corporate travelers, and solo passengers, this service ensures a comfortable and safe journey within the city and for long-distance travel."
  },
  {
    "name": "24×7 Cab Navi Mumbai",
    "description": "24×7 Cab Navi Mumbai ensures round-the-clock taxi availability for all travel needs. Whether it’s early morning airport transfers, late-night city rides, or emergency trips, passengers can rely on professional drivers, clean vehicles, and fast response times for uninterrupted travel."
  },
  {
    "name": "Sedan Cab Navi Mumbai",
    "description": "Sedan Cab Navi Mumbai offers comfortable sedan cars for city rides, airport pickups, and intercity trips. With AC-equipped vehicles, courteous chauffeurs, and reliable service, passengers can enjoy a smooth, stress-free, and safe travel experience throughout Navi Mumbai."
  },
  {
    "name": "SUV Cab Navi Mumbai",
    "description": "SUV Cab Navi Mumbai provides spacious and comfortable SUVs for family travel, group outings, and long-distance trips. Professional drivers, well-maintained vehicles, and 24×7 service ensure passengers travel in comfort and safety with flexible booking and transparent pricing."
  },
  {
    "name": "Vashi Taxi Service",
    "description": "Vashi Taxi Service specializes in reliable cab services in and around Vashi. With experienced drivers, prompt pickups, and clean, AC-enabled vehicles, passengers can enjoy hassle-free travel for local rides, airport transfers, or long-distance journeys within Navi Mumbai."
  },
  {
    "name": "Nerul Cab Service",
    "description": "Nerul Cab Service offers professional taxi services in the Nerul area of Navi Mumbai. Passengers benefit from well-maintained cars, courteous drivers, and 24×7 availability for city commutes, airport trips, or intercity travel with transparent pricing and easy online booking."
  },
  {
    "name": "Panvel Cab Service",
    "description": "Panvel Cab Service provides dependable cab services in and around Panvel, Navi Mumbai. Offering AC sedans and SUVs, professional chauffeurs, and timely pickups, the service caters to local commuters, airport transfers, and outstation travelers seeking safe and comfortable rides."
  },
  {
    "name": "Navi Mumbai Airport Cab",
    "description": "Navi Mumbai Airport Cab ensures safe and punctual transfers to and from Navi Mumbai Airport. With experienced drivers, well-maintained vehicles, and 24×7 availability, passengers can enjoy a stress-free ride with transparent fares, online booking, and timely service."
  },
  {
    "name": "Fast Cab Navi Mumbai",
    "description": "Fast Cab Navi Mumbai offers quick and efficient cab services for urgent travel needs. With prompt pickups, professional drivers, and well-maintained vehicles, passengers can rely on speedy and safe transport across Navi Mumbai, including airport transfers and city rides."
  },
  {
    "name": "Corporate Cab Navi Mumbai",
    "description": "Corporate Cab Navi Mumbai provides chauffeur-driven vehicles for employee transport, business trips, and corporate events. With professional drivers, AC sedans and SUVs, and flexible billing options, the service ensures punctual, safe, and comfortable travel for companies in Navi Mumbai."
  },
  {
    "name": "Outstation Cab Navi Mumbai",
    "description": "Outstation Cab Navi Mumbai offers long-distance travel to nearby cities and towns from Navi Mumbai. With experienced drivers, well-maintained vehicles, and transparent pricing, passengers can enjoy stress-free, comfortable, and safe journeys for one-way or round trips."
  },
  {
    "name": "Premium Cab Navi Mumbai",
    "description": "Premium Cab Navi Mumbai delivers luxury taxi services with high-end sedans and SUVs for VIP travel, special occasions, or corporate needs. Passengers benefit from professional chauffeurs, punctual service, and a comfortable, safe ride with online booking and transparent pricing."
  },
  {
    "name": "Safe Taxi Navi Mumbai",
    "description": "Safe Taxi Navi Mumbai ensures secure travel across the city and for outstation trips. With experienced drivers, real-time tracking, and well-maintained vehicles, passengers can enjoy a reliable, comfortable, and worry-free travel experience in Navi Mumbai."
  },
  {
    "name": "Online Cab Booking Navi Mumbai",
    "description": "Online Cab Booking Navi Mumbai allows passengers to book taxis conveniently from their smartphone or computer. Offering AC sedans, SUVs, and chauffeur-driven vehicles, the service provides quick confirmations, transparent fares, 24×7 availability, and hassle-free city and outstation travel."
  }
],

"tableData": [
  ["Navi Mumbai Taxi", "Cab Near Me Navi Mumbai"],
  ["Affordable Cab Navi Mumbai", "Best Cab Service Navi Mumbai"],
  ["24×7 Cab Navi Mumbai", "Sedan Cab Navi Mumbai"],
  ["SUV Cab Navi Mumbai", "Vashi Taxi Service"],
  ["Nerul Cab Service", "Panvel Cab Service"],
  ["Navi Mumbai Airport Cab", "Fast Cab Navi Mumbai"],
  ["Corporate Cab Navi Mumbai", "Outstation Cab Navi Mumbai"],
  ["Premium Cab Navi Mumbai", "Safe Taxi Navi Mumbai"],
  ["Online Cab Booking Navi Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Navi Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable cab services in Navi Mumbai, ideal for daily commutes, airport transfers, and city travel with comfort and safety."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to enjoy a smooth and comfortable ride across Navi Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Navi Mumbai Roads",
    "WhyChoosedescription": "Our professional drivers know all major routes and localities in Navi Mumbai, ensuring timely, safe, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer clear, upfront pricing—fuel, tolls, and driver allowances included—making your cab service in Navi Mumbai stress-free and reliable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for City Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your travel requirements in Navi Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your travel in Navi Mumbai smooth, comfortable, and worry-free."
  }
]


























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab services in Navi Mumbai?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services in Navi Mumbai for local travel, airport transfers, and outstation trips.',
  },
  {
    question: 'How can I book a cab in Navi Mumbai with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for hassle-free bookings.',
  },
  {
    question: 'What types of vehicles are available for cab service in Navi Mumbai?',
    answer: 'Shambhu Cabs offers a wide range of vehicles including sedans, SUVs, and luxury cars suitable for individual, family, and corporate travel in Navi Mumbai.',
  },
  {
    question: 'Are drivers experienced for cab services in Navi Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with Navi Mumbai routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for cab service in Navi Mumbai?',
    answer: 'Absolutely. You can select any pickup and drop-off points according to your convenience within Navi Mumbai.',
  },
  {
    question: 'Is cab service available 24x7 in Navi Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock cab services in Navi Mumbai to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for cab services in Navi Mumbai?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for cab service in Navi Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during cab journeys in Navi Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your cab journey in Navi Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Patel',
    feedback: 'Shambhu Cabs made traveling within Navi Mumbai very convenient. The driver was professional and the car was clean and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Rao',
    feedback: 'Highly reliable cab service in Navi Mumbai. Shambhu Cabs ensured a smooth and comfortable ride for our trip.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Navi Mumbai",
  "image": "https://www.shambhucab.com/assets/images/cab-service-navi-mumbai.jpg",
  "description": "Shambhu Cabs provides reliable cab services in Navi Mumbai including Vashi, Nerul, and Panvel. Choose from sedans, SUVs, and airport transfers. Available 24×7 for local rides, corporate travel, and outstation trips with safe and affordable options.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/cab-service-navi-mumbai"
  }
};






  return (
    <div>
<Helmet>
  <title>Cab Service in Navi Mumbai | Vashi, Nerul, Panvel Cabs | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book cab services in Navi Mumbai with Shambhu Cabs. Sedans, SUVs, and airport transfers available 24×7 for local rides, corporate travel, and outstation trips. Safe, fast, and affordable online booking."
  />

  <meta
    name="keywords"
    content="Navi Mumbai Taxi, Cab Near Me Navi Mumbai, Affordable Cab Navi Mumbai, Best Cab Service Navi Mumbai, 24×7 Cab Navi Mumbai, Sedan Cab Navi Mumbai, SUV Cab Navi Mumbai, Vashi Taxi Service, Nerul Cab Service, Panvel Cab Service, Navi Mumbai Airport Cab, Fast Cab Navi Mumbai, Corporate Cab Navi Mumbai, Outstation Cab Navi Mumbai, Premium Cab Navi Mumbai, Safe Taxi Navi Mumbai, Online Cab Booking Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinnavimumbai;